import type { StockQuantity } from '../types';

const getStockAfterQuantityReductions = (
    stock: StockQuantity,
    quantityToIgnore = 0
) => {
    const quantity = stock.quantity ?? 0;

    if (!stock.quantity) {
        return {
            stock,
            quantityToIgnore,
        };
    }

    if (quantityToIgnore > quantity) {
        return {
            stock: {
                ...stock,
                quantity: 0,
            },
            quantityToIgnore: quantityToIgnore - quantity,
        };
    }

    return {
        stock: {
            ...stock,
            quantity: quantity - quantityToIgnore,
        },
        quantityToIgnore: 0,
    };
};

export default getStockAfterQuantityReductions;
